import { loadCategoriesAction } from 'modules/categories/actions'
import { getCategoriesSelector } from 'modules/categories/selectors'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { isDifferentLocationUtil } from 'modules/router/utils'
import shouldLoadCategoriesRouteUtil from 'modules/routes/utils/should-load-categories'
import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import React from 'react'
import NavLink from 'components/NavLink'
import { sortByAlphabeticalOrder } from 'utils/array'
import { removeSpacesStringUtil } from 'utils/string'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import { usePreviousHookUtil } from 'modules/component/utils/hooks/usePrevious.js'
import { hasHeaderBannerSelect } from 'modules/headerBanner/selectors/hasHeaderBanner/index.js'
import {
  HEADER_BANNER_HEIGHT_DESKTOP,
  HEADER_BANNER_HEIGHT_SMALL_SCREEN
} from 'modules/headerBanner/constants/index.js'
import getPathnameRouterSelect from 'modules/router/selectors/get-pathname/index.js'
import { getSectionFromPathnameUtil } from 'pages/Search/index.js'

/**
 * @param query
 * @param location
 * @param match
 * @param route
 * @returns {JSX.Element}
 * @constructor
 */
export const SubNavBar = ({
  query,
  location,
  match,
  route
}) => {
  const categoriesState = useSelector(state => getCategoriesSelector()(state, { route }))
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const dispatch = useDispatch()
  const prevLocation = usePreviousHookUtil(location)
  const hasHeaderBanner = useSelector(hasHeaderBannerSelect)
  const pathname = useSelector(getPathnameRouterSelect)

  const loadData = () => {
    if (!shouldLoadCategoriesRouteUtil(route, match)) {
      return
    }

    dispatch(
      loadCategoriesAction({
        route: route,
        match: match
      })
    )
  }

  React.useEffect(() => {
    loadData()
  }, [])

  React.useEffect(() => {
    if (isDifferentLocationUtil(prevLocation, location)) {
      loadData()
    }
  }, [
    location,
    prevLocation
  ])

  const handleClickCategory = ({ url }) => {

  }

  if (!match) {
    return <></>
  }

  const getCategoryNames = () => {
    let categories = sortByAlphabeticalOrder(
      categoriesState.map(category => getValueReduxUtil(category, 'name'))
    )
    // If it has a 'all' category, make it the first index
    const index = categories.indexOf('all')
    if (index !== -1) {
      categories = [
        'all',
        ...categories.slice(0).filter(cat => cat !== 'all')
      ]
    }
    if (categories.includes('iamagymaholic')) {
      categories = [
        categories[0],
        'iamagymaholic',
        ...categories.slice(1).filter(cat => cat !== 'iamagymaholic')
      ]
    }
    return categories
  }

  const getUrl = (name) => {
    const { section } = route
    const isAll = name === 'all'
    if (section === SECTIONS_NAME.HOME) {
      return '/'
    }

    if (section === SECTIONS_NAME.PAGES) {
      return `/${name}`
    }

    let url = `/${section}` + (
      isAll ? '' : '/' + removeSpacesStringUtil(name)
    )

    if (section === SECTIONS_NAME.SEARCH && query) {
      url += `?q=${query}`
    }

    return url
  }

  const names = getCategoryNames()
  const { category } = match.params
  let categoryToUse
  const isSearchRoute = match?.pattern?.section === SECTIONS_NAME.SEARCH
  if (isSearchRoute) {
    categoryToUse = getSectionFromPathnameUtil(pathname)
  } else {
    categoryToUse = category
  }

  let marginTop = isSmallScreen ? '2.77em' : '4.44em'
  if (hasHeaderBanner && isSmallScreen) {
    marginTop = `calc(${marginTop} + ${HEADER_BANNER_HEIGHT_SMALL_SCREEN})`
  } else if (hasHeaderBanner && !isSmallScreen) {
    marginTop = `calc(${marginTop} + ${HEADER_BANNER_HEIGHT_DESKTOP})`
  }

  return (
    <div
      className='no-scrollbars'
      style={{
        padding: '0 1.33em',
        marginTop,
        lineHeight: '2.77em',
        overflowX: 'scroll',
        overflowY: 'visible',
        WebkitOverflowScrolling: 'touch',
        whiteSpace: 'nowrap',
        textTransform: 'capitalize',
        background: 'white',
        textAlign: 'center'
      }}
    >

      {
        names.map((name, i) => {
          const url = getUrl(name)
          const marginRight = (
            i === names.length - 1 ? null : STYLES_MARGIN.BIG
          )

          const isSameCategory = name === categoryToUse
          const isAll = /all/i.test(name)

          const isActiveParam = categoryToUse
            ? isSameCategory
            : isAll

          return (
            <NavLink
              end
              key={name}
              style={({ isActive }) => ({
                marginRight,
                height: isActive || isActiveParam ? 'calc(100% - 2px)' : '100%',
                borderBottom: isActive || isActiveParam ? '2px solid #191919' : 'initial',
                fontWeight: isActive || isActiveParam ? '600' : 'initial',
                color: isActive || isActiveParam ? '#191919' : 'currentColor',
                display: 'inline-block'
              })}
              onClick={() => handleClickCategory({ url })}
              to={url}
            >
              {name}
            </NavLink>
          )
        })
      }
    </div>
  )
}
